// extracted by mini-css-extract-plugin
export default {"secondmain":"Second_secondmain__xtAKs","round":"Second_round__OiL+j","second-heading":"Second_second-heading__eP+ut","image":"Second_image__LQXxn"};